import React, { useEffect } from 'react';
import { useWatch, UseFormMethods } from 'react-hook-form';
import { AdditionalDataViewModel } from 'api/additional-data/models/AdditionalDataViewModel';
import AdditionalDataFormItem from '../additionalDataFormItem/AdditionalDataFormItem';
import moment from 'moment';
// import { SelectValueLabel } from 'common/types/SelectValueLabel';

type Props = {
    form: UseFormMethods<any>;
    isDetails: boolean;
    className?: string;
    xl?: number;
    lg?: number;
    md?: number;
    sm?: number;
    xs?: number;
    initial?: AdditionalDataViewModel[]
};

const AdditionalDataForm: React.FC<Props> = ({ initial, xl, lg, md, sm, xs, form, isDetails, className }: Props) => {
    //const data = useFieldArray<AdditionalDataViewModel>({ control: form.control, name: 'additionalData', keyName: 'formId' as any });       
    const fields = useWatch<AdditionalDataViewModel[]>({ control: form.control, name: 'additionalData' });

    useEffect(() => {
        if (initial && (!fields || fields.length === 0)) {
            const list: AdditionalDataViewModel[] = [];
            initial.forEach(x => {
                list.push({ additionalDataId: x.additionalDataId, type: x.type, value: x.value, id: x.id, designation: x.designation });
            });
            form.setValue('additionalData', list);
        }
    }, [initial]);

    return (
        <>
            {fields && fields.length > 0 && <>
                {fields.map((ti, index) => {
                    if (ti.type === 'DATE' && typeof ti.value === 'string' && ti.value.includes('Z')) {
                        form.setValue(`additionalData[${index}].value`, moment.utc(ti.value).toDate());
                    }
                    return (
                        <AdditionalDataFormItem
                            className={className}
                            xl={xl}
                            lg={lg}
                            md={md}
                            sm={sm}
                            xs={xs}
                            key={index}
                            form={form}
                            isDetails={isDetails}
                            index={index}

                        />
                    );
                })}
            </>}

        </>
    );
}

export default AdditionalDataForm;
